module.exports = __webpack_public_path__ + "media/images/sidebar-indicator-98b9732903153a650178f616733e8c02.svg";